import { store } from '@/store'
const { VITE_GENESEE_FRONTEND_EVENTS_HOST } = import.meta.env;

export async function handleShoppinglistEvent(payload: any) {

  const url = `${VITE_GENESEE_FRONTEND_EVENTS_HOST}/wishlist-ecom-crm/api/v1/wishlist`;
  const { B2BToken } = store.getState().company.tokens;

  try {
    await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${B2BToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
  } catch (error) {
    console.log('error communicating with API.');
  }
}
